
export default class OverlayDiv extends React.Component { 
	static defaultProps = {
		imageUrl: null,
		height: 300,
		boxShadow: 0.6, 
		backgroundPosition: 'center',
		backgroundSize: 'cover'
	}

	getDivStyle() { 
		const divStyle = { 
			backgroundImage: `url('${this.props.imageUrl}')`,
			height: this.props.height ? this.props.height : '100%', /* You must set a specified height */
			backgroundSize: this.props.backgroundSize,
			backgroundPosition: this.props.backgroundPosition,
			boxShadow:`inset 0 0 0 2000px rgba(0,0,0,${this.props.boxShadow})`,
		}
		return divStyle
	}

	render() { 
		return <div style={{...this.getDivStyle(), ...this.props.style}} onClick={() => this.props.onClick ? this.props.onClick() : null}>
				{this.props.children}
			</div>
			}
}